import type { AnyNonNullish } from 'utils/types/AnyNonNullish';

export function objectShallowEquals<T extends AnyNonNullish>(
  o1: T,
  o2: T,
): boolean;
export function objectShallowEquals<T extends AnyNonNullish>(
  o1: T,
): (o2: T) => boolean;
export function objectShallowEquals<T extends AnyNonNullish>(
  o1: T,
  o2?: T,
): boolean | ((o2: T) => boolean) {
  // biome-ignore lint/style/noArguments: check whether the second argument was passed or not
  if (arguments.length === 1) {
    return (o2) => objectShallowEquals(o1, o2);
  }
  if (o1 === o2) {
    return true;
  }
  const keys = Object.keys(o1);
  if (keys.length !== Object.keys(o2!).length) {
    return false;
  }
  return keys.every((key) => o1[key as keyof T] === o2![key as keyof T]);
}
